import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';

import { enqueueNotification } from 'stores';
import * as utils from 'utils';

import { binderManagementReportingAxios } from '../../binderManagement.api';
import { BDX_REQUIRED_BDX } from '../../binderManagement.queryKeys';
import { useHandleError } from '../../binderManagement.utils';

interface IUnpublishReportResponse {
  facilityReference: string;
  callbackOnSuccess: (data: IReportingResponse) => void;
  data: IReportingResponse;
}

interface IUnpublishReportProps extends IUnpublishReportResponse {
  requestId: string;
}

export const useUnpublishReport = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = useHandleError({
    file: 'binderManagement.reporting.mutation.useUnpublishReport',
    warning: 'notification.bdxUnpublish.fail',
  });

  const handleSuccess = ({ facilityReference, callbackOnSuccess, data }) => {
    dispatch(enqueueNotification('notification.bdxUnpublish.success', 'success'));

    if (utils.generic.isFunction(callbackOnSuccess)) {
      callbackOnSuccess(data);
    }

    queryClient.invalidateQueries([BDX_REQUIRED_BDX, facilityReference]);
  };

  return useMutation<IUnpublishReportResponse, AxiosError, IUnpublishReportProps>(
    async ({ requestId, facilityReference, callbackOnSuccess }) => {
      const result = await binderManagementReportingAxios.put(`unpublish`, { requestId });

      return { facilityReference, callbackOnSuccess, data: result.data };
    },
    {
      onSuccess: handleSuccess,
      onError: handleError,
    }
  );
};
